import { ALL } from "../general/general";

export const HOME_PHASE = {
  UNDER_CONSTRUCTION: "UnderConstruction",
  UNDER_WARRANTY: "UnderWarranty",
  OUT_OF_WARRANTY: "OutOfWarranty",
  SERVICE: "Service",
};

export const HOME_PHASE_MAP = {
  [HOME_PHASE.UNDER_CONSTRUCTION]: {
    text: "Under Construction",
    color: "grey",
  },
  [HOME_PHASE.UNDER_WARRANTY]: { text: "Under Warranty", color: "success" },
  [HOME_PHASE.OUT_OF_WARRANTY]: { text: "Out of Warranty", color: "error" },
  [HOME_PHASE.SERVICE]: { text: "Service", color: "info" },
};

export const HOME_PHASE_OPTIONS = [
  { label: ALL, value: ALL },
  {
    label: "Under Construction",
    value: "UnderConstruction",
  },
  {
    label: "Under Warranty",
    value: "UnderWarranty",
  },
  {
    label: "Out Of Warranty",
    value: "OutOfWarranty",
  },
  {
    label: "Service",
    value: "Service",
  },
];
